import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle` 

  :root { 
    --very-dark-blue: #002a58;
    --white: #fff;
    --blue: #0672CB;
    --light-blue: #41B6E6;
    --cyan: #94DCF7;
    --primary-blue: #0672CB;
    --hover: #0063b8;
    --dark-blue: #00467E;
    --lisa-background: #839db4;
    --gray: #808080;
    --text-gray: #444444;
    --clear-gray: #7E7E7E;
    --scrollbar: #949494;
    --neutral-gray: #636363;
    --chat-background: #1d2c3b;
    --light-gray: #E4E4E4;
    --black: #000000;
    --light-black: #0E0E0E;
    --lisa-container: #839db4;
    --white-smoke: #cfcfcf;
    --light-green: #bed893;
    --cloud-gray: #F0F0F0;
    --orange-yellow: #e7bc22;
  }

  #root{
    height: 100%;
  }

  * { 
    margin: 0; 
    padding: 0; 
    box-sizing: border-box; 
  }

  html{
    @media (max-width: 1080px){ 
      font-size: 93.75% 
    }
    @media (max-width: 720px){ 
      font-size: 87.5%; 
    }
  }

  body{
    -webkit-font-smoothing: antialiased;
    background: linear-gradient(180deg, #0076CE 0%, #41B6E6 100%);
    font-family: "Roboto", sans-serif;
    height: 100vh;
  }
  body:fullscreen, body::backdrop {
    -webkit-font-smoothing: antialiased;
    background: linear-gradient(180deg, #0076CE 0%, #41B6E6 100%);
    font-family: "Roboto", sans-serif;
    height: 100vh;
  }

  h1,h2,h3,h4,h5,h6, strong{ 
    font-weight: 600; 
  } 

  button { 
    cursor: pointer; 
  } 

  [disabled] { 
    opacity: 0.6; 
    cursor: not-allowed; 
  }

`;
